{
  "calendar.tab": "Calendar",
  "calendar.today": "Today",
  "calendar.loadError": "We couldn't load the calendar.",
  "calendar.truncated": "This range holds more tasks than the calendar shows at once. Pick one person or switch to a week to see them all.",
  "calendar.caption": "{count, plural, =0 {Nothing scheduled} one {# task on the calendar} other {# tasks on the calendar}}",
  "calendar.nav.previousMonth": "Previous month",
  "calendar.nav.nextMonth": "Next month",
  "calendar.nav.previousWeek": "Previous week",
  "calendar.nav.nextWeek": "Next week",
  "calendar.mode.label": "Calendar view",
  "calendar.mode.month": "Month",
  "calendar.mode.week": "Week",
  "calendar.filters.showDone": "Show done",
  "calendar.summary.label": "This period in numbers",
  "calendar.summary.none": "None",
  "calendar.summary.dueMonth": "Due this month",
  "calendar.summary.dueWeek": "Due this week",
  "calendar.summary.doneCaption": "{count, plural, =0 {Nothing done yet} one {# already done} other {# already done}}",
  "calendar.summary.overdue": "Overdue",
  "calendar.summary.milestones": "Milestones",
  "calendar.summary.undated": "No date yet",
  "calendar.day.label": "{date}: {count, plural, =0 {nothing} one {# item} other {# items}}",
  "calendar.more": "{count, plural, one {+# more} other {+# more}}",
  "calendar.more.label": "Show {count, plural, one {# more item} other {# more items}} on {date}",
  "calendar.chip.overdue": "Overdue",
  "calendar.chip.milestone": "Milestone, {range}, {status}",
  "calendar.chip.projected": "Repeats on this day. The task is created a few days before.",
  "calendar.span.range": "{start} – {end}",
  "calendar.week.label": "Week of {start}",
  "calendar.week.empty": "Nothing due this week.",
  "calendar.agenda.label": "Days with work",
  "calendar.agenda.emptyTitle": "A clear stretch",
  "calendar.agenda.emptyBody": "Nothing is due in these days.",
  "calendar.agenda.nothingToday": "Nothing due today.",
  "calendar.unscheduled.title": "No date yet",
  "calendar.unscheduled.hint": "Drag a task onto a day to give it a due date.",
  "calendar.unscheduled.emptyTitle": "Everything has a date",
  "calendar.unscheduled.emptyBody": "Open tasks without a due date show up here.",
  "calendar.legend.label": "What the marks mean",
  "calendar.legend.task": "Task, by status",
  "calendar.legend.overdue": "Overdue",
  "calendar.legend.milestone": "Milestone",
  "calendar.legend.repeat": "Coming repeat",
  "calendar.dnd.instructions": "To move a task to another day, press Space, choose the day with the arrow keys, then press Space again. Escape cancels. Enter opens the task.",
  "calendar.dnd.picked": "Picked up {title}. Use the arrow keys to choose a day.",
  "calendar.dnd.over": "{title}: {date}.",
  "calendar.dnd.dropped": "{title} is now due on {date}.",
  "calendar.dnd.droppedUnscheduled": "{title} no longer has a due date.",
  "calendar.dnd.cancelled": "{title} stays where it was.",
  "calendar.moved": "“{title}” is now due on {date}.",
  "calendar.movedUnscheduled": "“{title}” no longer has a due date.",
  "calendar.moveConflict": "Someone changed this task a moment ago. The calendar now shows the latest.",
  "calendar.moveDenied": "You can't change this task's dates."
}
